import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'htc-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HtcHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
